import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../../state/reducers';
import { IProps, IStateProps } from './interfaces';
import {
  Container,
  ImageWrapper,
  Image,
} from './styles';
import { VaultButton } from '../../../../Shared';

const ExchangeImageContent: React.FC<IProps> = (props: IProps) => (
  <Container>
    <ImageWrapper>
      <Image id="AssetDetails.MediaContent.ImageContent" src={props.source} data-tip="Preview" />
      <VaultButton
        id="AssetDetails.MediaContent.ImageContent.PreviewButton"
        variant="transparentOnBlack"
        style={{ position: 'absolute', bottom: 5, right: 5 }}
        onClick={() => null}
        data-tip="Image Preview"
        data-for="operations-tooltip"
      />
    </ImageWrapper>
  </Container>
);

const mapStateToProps = (state: IAppState): IStateProps => ({
  source: state.exchange?.activeAsset?.mediaInformation?.source ?? '',
});

export default connect(
  mapStateToProps,
)(ExchangeImageContent);
